export const SEND_VERIFICATION_CODE = 'onsite-booking/SEND_VERIFICATION_CODE';
export const SEND_VERIFICATION_CODE_SUCCESS =
  'onsite-booking/SEND_VERIFICATION_CODE_SUCCESS';
export const SEND_VERIFICATION_CODE_ERROR =
  'onsite-booking/SEND_VERIFICATION_CODE_ERROR';

export const VERIFY_CODE = 'onsite-booking/VERIFY_CODE';
export const VERIFY_CODE_SUCCESS = 'onsite-booking/VERIFY_CODE_SUCCESS';
export const VERIFY_CODE_ERROR = 'onsite-booking/VERIFY_CODE_ERROR';

export const LOAD_ONSITE_BOOKING_SLOT =
  'onsite-booking/LOAD_ONSITE_BOOKING_SLOT';
export const LOAD_ONSITE_BOOKING_SLOT_SUCCESS =
  'onsite-booking/LOAD_ONSITE_BOOKING_SLOT_SUCCESS';
export const LOAD_ONSITE_BOOKING_SLOT_ERROR =
  'onsite-booking/LOAD_ONSITE_BOOKING_SLOT_ERROR';

export const HOLD_ONSITE_BOOKING_SLOT =
  'onsite-booking/HOLD_ONSITE_BOOKING_SLOT';
export const HOLD_ONSITE_BOOKING_SLOT_SUCCESS =
  'onsite-booking/HOLD_ONSITE_BOOKING_SLOT_SUCCESS';
export const HOLD_ONSITE_BOOKING_SLOT_ERROR =
  'onsite-booking/HOLD_ONSITE_BOOKING_SLOT_ERROR';

export const RELEASE_ONSITE_BOOKING_SLOT =
  'onsite-booking/RELEASE_ONSITE_BOOKING_SLOT';
export const RELEASE_ONSITE_BOOKING_SLOT_SUCCESS =
  'onsite-booking/RELEASE_ONSITE_BOOKING_SLOT_SUCCESS';
export const RELEASE_ONSITE_BOOKING_SLOT_ERROR =
  'onsite-booking/RELEASE_ONSITE_BOOKING_SLOT_ERROR';

export const BOOK_APPOINTMENT = 'onsite-booking/BOOK_APPOINTMENT';
export const BOOK_APPOINTMENT_SUCCESS =
  'onsite-booking/BOOK_APPOINTMENT_SUCCESS';
export const BOOK_APPOINTMENT_ERROR = 'onsite-booking/BOOK_APPOINTMENT_ERROR';

export const SAVE_SELECTED_ONSITE_BOOKING_SLOT =
  'onsite-booking/SAVE_SELECTED_ONSITE_BOOKING_SLOT';
export const SAVE_SELECTED_ONSITE_BOOKING_SLOT_SUCCESS =
  'onsite-booking/SAVE_SELECTED_ONSITE_BOOKING_SLOT_SUCCESS';
export const SAVE_SELECTED_ONSITE_BOOKING_SLOT_ERROR =
  'onsite-booking/SAVE_SELECTED_ONSITE_BOOKING_SLOT_ERROR';

export const RESET_SELECTED_ONSITE_BOOKING_SLOT =
  'onsite-booking/RESET_SELECTED_ONSITE_BOOKING_SLOT';

export const UPLOAD_PATIENT_SIGNATURE =
  'onsite-booking/UPLOAD_PATIENT_SIGNATURE';
export const UPLOAD_PATIENT_SIGNATURE_SUCCESS =
  'onsite-booking/UPLOAD_PATIENT_SIGNATURE_SUCCESS';
export const UPLOAD_PATIENT_SIGNATURE_ERROR =
  'onsite-booking/UPLOAD_PATIENT_SIGNATURE_ERROR';
export const RESET_CURRENT_HOLDING_SLOT =
  'onsite-booking/RESET_CURRENT_HOLDING_SLOT';
